import type { CaseDetail } from '../portfolio';

const originDesignThinkingCase: CaseDetail = {
  id: 'origin-design-thinking',
  project: 'デザイン思考の原点 — アフォーダンス研究と空間・体験設計',
  client: '多摩美術大学大学院 / 乃村工藝社グループ',
  year: 'Archive',
  category: 'ARCHIVE / RESEARCH / EXPERIENCE',
  role: 'Design Research / Sign Design / Spatial Design / Experience Design',
  issue: '多摩美術大学大学院でのデザイン研究において、人間の認知・行動と空間・環境との関係を体系的に理解する手法が必要だった。動的な環境の経路認知に基づくアフォーダンスデザイン手法を確立し、サイン・環境グラフィック・空間体験設計に活かす方法論を構築する必要があった。',
  challenge: '空間における人の行動予測と、環境のグラフィックデザイン手法を紐づける方法論を研究すること。そして、乃村工藝社グループでの実務設計経験を通じて、サイン・空間デザインの最前線でのアフォーダンス理論の実践的検証を行うこと。',
  insight: '人間は空間に対して「アフォーダンス」— つまり「何ができるか」を潜在的に知覚する。動的な環境の経路認知に基づく手法で、人の身体行動と視覚的認知を分析し、情報群・メディアとしての環境をグラフィックデザインとして構成することで、より自然な行動誘導と空間体験が実現できる。',
  strategy: '多摩美術大学大学院において「動的な環境の経路認知に基づくアフォーダンスデザイン手法研究」を実施。日本サイン学会と日本サインデザイン協会で発表。同時に、乃村工藝社グループ（ノムラコムス）でデザイナーとしてサイン・グラフィック・空間デザインの実務設計・施工管理を担当。研究と実務を双方向で結びつけることで、デザイン思考の原点を確立。',
  experience: '大学院研究では、対象空間の経路認知をシークエンスで分析し、身体行動と環境の反応関係をグランドレベルでリサーチ。実務では、UDX、エバール化粧品、取手市、ユニリーバなどのサイン・空間デザインを企画・設計・施工管理。',
  output: 'アフォーダンスデザイン手法研究 / サイン・グラフィックデザイン設計 / 空間デザイン提案 / 施工管理 / 学会発表',
  impact: '現在のデザイン思考・CX・Experience Designへと繋がる「デザイン思考の原点」として、アフォーダンス理論をデザイン実践に活かす基盤を確立。',
  images: [
    {
      src: '/assets/migrated/9345e063ab11ac4ad60c.webp',
      caption: 'GRAPHIC DESIGN - STUDIES — 多摩美術大学 大学院 デザイン専攻 グラフィックデザイン領域 研究',
      large: true,
    },
    {
      src: '/assets/migrated/ce41384d0c2eb3120665.webp',
      caption: 'ORIGIN OF DESIGN THINKING — アフォーダンス研究と空間・体験設計の全体像',
      large: true,
    },
    {
      src: '/assets/migrated/17b782a6867d6fe88a30.webp',
      caption: 'PROPOSAL PLAN — グラフィックデザイン領域 デザイン研究 / 駅空間・公共空間のアフォーダンスデザイン計画',
      large: true,
    },
    {
      src: '/assets/migrated/e96c52773f26800124c0.webp',
      caption: '多摩美術大学大学院 デザイン研究 1/2 — 動的な環境の経路認知に基づくアフォーダンスデザイン手法研究',
      large: true,
    },
    {
      src: '/assets/migrated/af69fdbba85bf98ca030.webp',
      caption: '乃村工藝社 / ノムラコムス 実績 — サインデザイン設計・プロポーザルプラン / デザイン設計担当',
      large: true,
    },
  ],
};

export default originDesignThinkingCase;